import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import history from '../../history';
import { setEditStake } from '../rootReducer';
import { STATUS } from '../../utils/status';
import { calculateWin } from '../CreateStake/OddsSlider';
import { addStake, updateStake, deleteStake } from '../../firebase';
import ViewStake from './ViewStake';

class ConfirmEditStake extends Component {
  static propTypes = {
    userProfile: PropTypes.object.isRequired,
    editStake: PropTypes.object
  };

  state = {
    isLoading: false
  }

  confirmEdit = () => {
    this.setState({isLoading: true});
    const ogStake = {...this.props.originalStake};
    let editedStake = this.props.editedStake;
    
    // Validate my available balance
    const currentLiability = calculateWin(ogStake.amount, ogStake.odds);

    if (editedStake.amount - currentLiability > this.props.availableBalance) {
      console.log("Insufficient Balance"); //Todo: display to user
      return;
    }
    
    if (editedStake.status === STATUS.Reissued) {
        // Delete the original stake, this edited stake will become the new original
        deleteStake(editedStake.originalStakeId);
    }

    // Staker becomes the stakee
    editedStake.stakeeProfile = editedStake.stakerProfile;
    editedStake.stakee = editedStake.stakerId;

    // I become the Staker
    const { sub, nickname, picture } = this.props.userProfile;
    editedStake.stakerId = sub;
    editedStake.stakerProfile = { name: nickname, avatar: picture};

    // Is a clone of the original stake with new properties, so save ref to original id
    editedStake.originalStakeId = editedStake.id;
    editedStake.status = STATUS.Reissued;

    addStake(editedStake)
      .then(() => {
        this.props.setEditStake(null);
        history.push('/');
      })
      .catch(error => {
        console.error('Error adding document: ', error);
        this.setState({isLoading: false});
      });

    ogStake.isBeingEdited = true;
    updateStake(ogStake, ogStake.id);
  };

  render() {
    const { isLoading } = this.state;
    let { editedStake } = this.props;

    if (!editedStake) return <Redirect to="/" />

    return (
      <ViewStake
        stake={editedStake}
        actions={
          <Button fluid primary size="large" loading={isLoading} disabled={isLoading} onClick={this.confirmEdit}>
            Confirm Edit
          </Button>
        }
      />
    );
  }
}

const mapStateToProps = ({ auth, app }) => ({
  userProfile: auth.profile,
  availableBalance: app.availableBalance,
  editedStake: app.editedStake,
  originalStake: app.editOriginalStake,
  users: app.users
});

export default connect(mapStateToProps, { setEditStake})(ConfirmEditStake);



// WEBPACK FOOTER //
// ./src/App/ViewStake/ConfirmEditStake.js